'use strict';

import angular from 'angular';

import { findByKeyValue } from './find';


export default function() {
	'ngInject';

	return {
		require: '^ngModel',
		link: link,
		scope: {
			initialValue: '<',
		},
	};

	function link(scope, element, attrs, ngModelCtrl) {
		const state = {
			value: angular.copy(scope.initialValue) || [],
			keys: new Map(),
			contains: (itemKey) => {
				return state.keys.has(itemKey);
			},
			size: () => {
				return state.value.length;
			},
			clear: () => {
				state.value.length = 0;
				state.keys.clear();
			},
			toggleByKey: (key, item) => {
				if (!state.contains(item[key])) {
					_addItem(key, item);
				} else {
					_removeItem(key, item);
				}
			},
			toggleAllByKey: (key, items) => {
				const missingItems = [];
				for (const x of items) {
					if (!state.keys.has(x[key])) {
						missingItems.push(x);
					}
				}
				if (missingItems.length > 0) {
					for (const item of missingItems) {
						_addItem(key, item);
					}
				} else {
					state.clear();
				}
			},
		};

		function _addItem(key, item) {
			if (!state.keys.has(item[key])) {
				state.keys.set(item[key], item);
				state.value.push(item);
			}
		}

		function _removeItem(key, item) {
			state.keys.delete(item[key]);
			const result = findByKeyValue(state.value, key, item[key]);
			if (result.index >= 0) {
				state.value.pop(result.index)
			}
		}

		ngModelCtrl.$setViewValue(state);

	}
}
